import axiosInstance from '../utils/AxiosConfig';

export const getStockMovements = async (page = 1, pageSize = 10, searchTerm = '', locationId = null, options = {}) => {
    const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString()
    });
    
    // Agregar search solo si hay contenido
    if (searchTerm && typeof searchTerm === 'string' && searchTerm.trim()) {
        params.append('search', searchTerm.trim());
    }
    
    // Agregar locationId si se proporciona
    if (locationId) {
        params.append('locationId', locationId.toString());
    }
    if (options.sortField) params.append('sortField', options.sortField);
    if (options.sortDirection) params.append('sortDirection', options.sortDirection);
    if (options.filterField) params.append('filterField', options.filterField);
    if (options.filterOperator) params.append('filterOperator', options.filterOperator);
    if (options.filterValue !== undefined && options.filterValue !== null && options.filterValue !== '') {
        params.append('filterValue', options.filterValue.toString());
    }
    
    const response = await axiosInstance.get(`/stock/movements?${params}`);
    return response.data.data;
};

export const createStockMovement = async (movement) => {
    const response = await axiosInstance.post('/stock/move', movement);
    return response.data.data;
};

export const getStockSummary = async (page = 1, pageSize = 10, searchTerm = '', options = {}) => {
    const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString()
    });
    
    // Agregar search solo si hay contenido
    if (searchTerm && typeof searchTerm === 'string' && searchTerm.trim()) {
        params.append('search', searchTerm.trim());
    }
    if (options.sortField) params.append('sortField', options.sortField);
    if (options.sortDirection) params.append('sortDirection', options.sortDirection);
    if (options.filterField) params.append('filterField', options.filterField);
    if (options.filterOperator) params.append('filterOperator', options.filterOperator);
    if (options.filterValue !== undefined && options.filterValue !== null && options.filterValue !== '') {
        params.append('filterValue', options.filterValue.toString());
    }
    
    const response = await axiosInstance.get(`/stock/summary?${params}`);
    return response.data.data;
};
